import React, { useState, useEffect } from 'react';
import request from 'utils/request_ajax';

import { routes } from 'constants/config';
import AuthorizationContext from './AuthorizationContext';

import getPermissionsInitialized from './utils/getPermissionsInitialized';
import setPermissionsInitialized from './utils/setPermissionsInitialized';

function fetchPermissions(options = { debug: false }) {
  pubsub.publish('permissions:update', { isLoading: true });

  request
    .get(routes.PERMISSIONS(options))
    .then(data => {
      pubsub.publish('permissions:update', {
        isLoading: false,
        permissions: data.permissions,
      });
    })
    .catch(e => {
      console.error(e);
      pubsub.publish('permissions:update', { isLoading: false, isError: true });
    });
}

function initializePermissions(options = {}) {
  const arePermissionsInitialized = getPermissionsInitialized();

  if (!arePermissionsInitialized) {
    setPermissionsInitialized(true);
    fetchPermissions(options);
  }
}

export default function AuthorizationProvider({ children }) {
  const [state, setState] = useState({
    initializePermissions,
    isLoading: true,
    isError: false,
    permissions: {},
  });

  useEffect(() => {
    pubsub.subscribe('permissions:update', data =>
      setState(previousState => ({ ...previousState, ...data })),
    );

    return pubsub.unsubscribe('permissions:update', data =>
      setState(previousState => ({ ...previousState, ...data })),
    );
  }, []);

  return (
    <AuthorizationContext.Provider value={state}>
      {children}
    </AuthorizationContext.Provider>
  );
}
